// JS file for PortfolioItem

import u from '@main';
import '@vendor/swiper/swiper-bundle.min.js?99141f134376ef9b3794c167';
import '@vendor/@fancyapps/ui/dist/fancybox.umd.js?99141f134376ef9b3794c167';
u.importCSS('@vendor/@fancyapps/ui/dist/fancybox.css');
u.importCSS('@vendor/swiper/swiper-bundle.min.css');

const bottomSwiper = new Swiper('.j-bottom-swiper', {
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
});

const topSwiper = new Swiper('.j-top-swiper', {
  navigation: {
    nextEl: '.c-next-button',
    prevEl: '.c-prev-button',
  },
  thumbs: {
    swiper: bottomSwiper,
  },
});
